import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6b9d0b09&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6b9d0b09&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9d0b09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\project\\bigBee\\bigbee_backend_ui_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9d0b09')) {
      api.createRecord('6b9d0b09', component.options)
    } else {
      api.reload('6b9d0b09', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6b9d0b09&scoped=true", function () {
      api.rerender('6b9d0b09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/screen/index.vue"
export default component.exports